import { render } from "./CampusDropDown.vue?vue&type=template&id=6b0a47a4&scoped=true"
import script from "./CampusDropDown.vue?vue&type=script&lang=js"
export * from "./CampusDropDown.vue?vue&type=script&lang=js"

import "./CampusDropDown.vue?vue&type=style&index=0&id=6b0a47a4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6b0a47a4"

export default script